<template>
  <div class="root-iframe">
    <iframe
      ref="iframe"
      width="100%"
      height="100%"
      :src="signal"
      frameborder="0"
    ></iframe>
  </div>
</template>

<script>
// 接口
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
export default {
  data() {
    return {
      smartAPI: ApiMethods.AIDocSmart,
      signal: ""
    };
  },
  created() {
    const { url } = this.$route.query;
    this.signal = url;
  },
  layout: "fullpage"
};
</script>

<style scoped lang="less">
.root-iframe {
  height: 85vh;
}
</style>



// WEBPACK FOOTER //
// pages/iframeView/examineInfo.vue